import {
  SET_UOM_MANAGEMENT,
  SET_UOM_RATIO,
  SET_UOM_RATIOTWO,
  SET_RATIO_CONVERSATION,
} from "../../types";

const initialState = {
  getAllUom: {},
  getAllUomRatio: {},
  getAllUomRatioTwo: {},
  getAllConversation: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UOM_MANAGEMENT:
      return {
        ...state,
        getAllUom: action.payload,
      };
    case SET_UOM_RATIO:
      return {
        ...state,
        getAllUomRatio: action.payload,
      };
    case SET_UOM_RATIOTWO:
      return {
        ...state,
        getAllUomRatioTwo: action.payload,
      };
    case SET_RATIO_CONVERSATION:
      return {
        ...state,
        getAllConversation: action.payload,
      };
    default:
      return state;
  }
}
